module.exports = __webpack_public_path__ + "components/flag/static/square/li-6a1a574241dd72a76c3d048b6ec08437.svg";